module.exports = __webpack_public_path__ + "img/logo_columbus.aab2c107.png";